import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import { format, utcToZonedTime } from 'date-fns-tz';

import Button from 'molecules/Button';
import Container from 'molecules/Container';
import Hero from 'organisms/Hero';
import Image from 'molecules/Image';
import WithBGImage from 'molecules/WithBGImage';
import { devlog } from 'lib/helpers';

import './ContactRep.scss';

/**
 * Contact Rep.
 */
const propTypes = {
  data: PropTypes.object.isRequired,
  hideLeaveMessage: PropTypes.bool,
}
const ContactRep = React.memo( p => {

  const date = new Date();
  const utahDate = utcToZonedTime( date, 'America/Denver' );
  const utahTime = format( utahDate, 'HHmm' );
  const day = format( utahDate, 'E' );
  const isAvailable = do {

    if(
      typeof window === 'undefined' ||
      day === 'Sat' ||
      day === 'Sun' ||
      '0900' > utahTime ||
      utahTime >= '1700'
    ) {
      return false;
    }
    else {
      return true;
    }

  }

  /* ------ = Output. = --------------------------------------------------------------------- */
  return(

    <div className={ classnames( 'ContactRep', p.className ) }>

      { !! p.data.salesRepPhoto &&

        <Image
        className="ContactRep__photo"
        data={ typeof p.data.salesRepPhoto !== 'string' ? p.data.salesRepPhoto : null }
        src={ typeof p.data.salesRepPhoto === 'string' ? p.data.salesRepPhoto : null }
        alt={ `Photo of ${p.data.salesRep.firstname}` }
        />

      }

      { !! p.data.salesRep &&

        <p className="ContactRep__txt">
          { p.data.salesRep.message }
        </p>

      }

      { !! p.data.salesRep && isAvailable

        ?

          <>

            <h3 className="ContactRep__online">
              { p.data.salesRep.firstname } is online now!
            </h3>

            <Button
            size="lg"
            link={ {
              to: `tel:${p.data.salesRep.phone}p${ p.data.salesRep.extension || ''}`,
            } }
            >
              { p.data.salesRep.phone } { p.data.salesRep.extension ? ` ext. ${p.data.salesRep.extension}` : '' }
            </Button>

            <a
            className="ContactRep__schedule"
            href="https://calendly.com/_dartdrones"
            target="_blank"
            >
              Or schedule a call
            </a>

          </>

        :

          <>

            <h3 className="ContactRep__online">
              { p.data.salesRep.firstname } is happy to help
            </h3>
            <Button
            size="lg"
            link={ {
              to: `https://calendly.com/_dartdrones`,
              target: '_blank',
            } }
            >
              Schedule a call
            </Button>

            { ! p.hideLeaveMessage &&
              <a
              className="ContactRep__schedule"
              href="#bottom-cta"
              >
                Or leave us a message
              </a>
            }

          </>


      }


    </div>


  )

} );
ContactRep.propTypes = propTypes;

export default ContactRep;


